export default __webpack_public_path__ + "book_details-lexile.71ad5d50.png";